module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-detail"
  }, [_c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("企业全称")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.orgdetail.name))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("统一社会信用代码")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.orgdetail.code))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("营业执照")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden",
      "border-radius": "5px"
    }
  }, [_c('viewer', {
    staticClass: "seeBigImg",
    attrs: {
      "images": _vm.photo
    }
  }, _vm._l((_vm.photo), function(src, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": src
      }
    })
  }))], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("行业")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.formatName))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("企业法人")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.orgdetail.legalPerson))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.orgdetail.phone))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("注册地址")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_c('span', {
    staticClass: "form-registry"
  }, [_vm._v(_vm._s(_vm.orgdetail.provinceName))]), _vm._v(" "), _c('span', {
    staticClass: "form-registry"
  }, [_vm._v(_vm._s(_vm.orgdetail.cityName))]), _vm._v(" "), _c('span', {
    staticClass: "form-registry"
  }, [_vm._v(_vm._s(_vm.orgdetail.countyName))]), _vm._v(" "), _c('span', {
    staticClass: "form-registry"
  }, [_vm._v(_vm._s(_vm.orgdetail.address))])])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("中心坐标")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v("东经：" + _vm._s(_vm._f("formatDegree")(_vm.orgdetail.longitude)) + "，北纬：" + _vm._s(_vm._f("formatDegree")(_vm.orgdetail.latitude)))])]), _vm._v(" "), (_vm.orgdetail.zone) ? _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("工业园区")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.orgdetail.zone.name))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("规模")]), _vm._v(" "), (_vm.orgdetail.regionType == 1) ? _c('span', {
    staticClass: "form-rt"
  }, [_vm._v("单个区县")]) : _vm._e(), _vm._v(" "), (_vm.orgdetail.regionType == 2) ? _c('span', {
    staticClass: "form-rt"
  }, [_vm._v("跨区县")]) : _vm._e(), _vm._v(" "), (_vm.orgdetail.regionType == 3) ? _c('span', {
    staticClass: "form-rt"
  }, [_vm._v("跨市")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("所属区划")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, _vm._l((_vm.orgdetail.regions), function(m) {
    return _c('p', {
      key: m.id
    }, [_c('span', {
      staticClass: "form-registry"
    }, [_vm._v(_vm._s(m.city.name))]), _vm._v(" "), _vm._l((m.county), function(n) {
      return _c('span', {
        key: n.id,
        staticClass: "form-registry"
      }, [_vm._v(_vm._s(n.name))])
    })], 2)
  }))]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("编制单位")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_c('p', [_c('el-radio-group', {
    on: {
      "change": _vm.changeradio
    },
    model: {
      value: (_vm.orgdetail.delegated),
      callback: function($$v) {
        _vm.$set(_vm.orgdetail, "delegated", $$v)
      },
      expression: "orgdetail.delegated"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("本单位")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("编制单位")])], 1)], 1)])]), _vm._v(" "), (_vm.orgdetail.delegated == true) ? _c('div', [_c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("编制单位名称")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "编制单位名称"
    },
    model: {
      value: (_vm.orgdetail.delegateOrgName),
      callback: function($$v) {
        _vm.$set(_vm.orgdetail, "delegateOrgName", $$v)
      },
      expression: "orgdetail.delegateOrgName"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("编制单位地址")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "编制单位地址"
    },
    model: {
      value: (_vm.orgdetail.delegateOrgAddr),
      callback: function($$v) {
        _vm.$set(_vm.orgdetail, "delegateOrgAddr", $$v)
      },
      expression: "orgdetail.delegateOrgAddr"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("编制单位联系人")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "编制单位联系人"
    },
    model: {
      value: (_vm.orgdetail.delegateOrgLinkMan),
      callback: function($$v) {
        _vm.$set(_vm.orgdetail, "delegateOrgLinkMan", $$v)
      },
      expression: "orgdetail.delegateOrgLinkMan"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("编制单位联系电话")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "编制单位联系电话"
    },
    model: {
      value: (_vm.orgdetail.delegateOrgPhone),
      callback: function($$v) {
        _vm.$set(_vm.orgdetail, "delegateOrgPhone", $$v)
      },
      expression: "orgdetail.delegateOrgPhone"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7320c331","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/weather/entDetail.vue
// module id = 1249
// module chunks = 2